module.exports = __webpack_public_path__ + "6811d5f4aeef0f9469cd8d6d64d0f8fe.jpg";